import type { WrappedLoadingSkeletonProps } from './types.js';

/** See index.d.ts for @finn-no/tjt-common-components for end user documentation.
 */
const WrappedLoadingSkeleton = (props: WrappedLoadingSkeletonProps) => {
    const { isLoading, className, style, children } = props;
    if (isLoading) {
        return (
            <div className={`tjt-skeleton ${className ?? ''}`} style={style}>
                <span className="invisible">{children}</span>
            </div>
        );
    }
    return <>{children}</>;
};

export default WrappedLoadingSkeleton;
